import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Col, Row, Card, Container } from "react-bootstrap"
import { useParams } from "react-router"
import SettingSetions from "@/components/Settings/SettingSections"
import UserComponent from "@/components/Settings/UserComponent"
import CategoryComponent from "@/components/Settings/CategoryComponent"
import StagesComponent from "@/components/Settings/StagesComponent"
import PlaceStatusComponent from "@/components/Settings/PlaceStatusComponent"
import PlaceVisitComponent from "@/components/Settings/PlaceVisitComponent"



interface SettingsDTO {
	id: string
}
const SettingsPage = () => {
	const { id } = useParams<SettingsDTO>()
	const [section, setSection] = useState("")
	const loadedSettings = SettingSetions

	const [t] = useTranslation("global")
	const toggle = (obj: string) => {
		setSection(obj)
	}
	return (
		<>
			{section === "users" && <UserComponent show={true} toggle={toggle} />}
			{section === "categories" && (
				<CategoryComponent show={true} toggle={toggle} />
			)}
			{section === "stages" && <StagesComponent show={true} toggle={toggle} />}
			{section === "status" && (
				<PlaceStatusComponent show={true} toggle={toggle} />
			)}
			{section === "placeVisit" && (
				<PlaceVisitComponent show={true} toggle={toggle} />
			)}


			<Container>
				<Row className="my-4">
					<Col xs={12}>
						<Row>

							<Col xs={12}>
								{Array.isArray(loadedSettings) &&
									loadedSettings.map((mainSection, index) => {
										if (
											mainSection.requiredParent &&
											mainSection.parentId !== id
										)
											return null
										return (
											<Card className="shadow-sm mb-2" key={index}>
												<Card.Header>
													<Card.Title>{t(mainSection.name)}</Card.Title>
												</Card.Header>
												<Card.Body>
													<ul className="nav nav-pills nav-fill  flex-column ">
														{mainSection.sections.map(
															(subSection, subSectionIndex) => {
																return (
																	<li
																		className="nav-item "
																		key={subSectionIndex}
																	>
																		<button
																			className={
																				" btn-block btn  text-left " +
																				(section === subSection.reference
																					? "btn-primary"
																					: "btn")
																			}
																			onClick={() => {
																				toggle(subSection.reference)
																			}}
																		>
																			{t(subSection.label)}
																		</button>
																	</li>
																)
															}
														)}
													</ul>
												</Card.Body>
											</Card>
										)
									})}
							</Col>
						</Row>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export default SettingsPage
